export function makeMinNumber<T>(minNumber: number, errorMsg: T) {
  return (value?: string | number) => {
    const validatingValue = Number(value);

    if (
      typeof validatingValue === 'number' &&
      (validatingValue === 0 || validatingValue) &&
      validatingValue < minNumber
    ) {
      return errorMsg;
    }

    return undefined;
  };
}
